<div class="col-12 px-0">
  <div class="form-group row">
    <div class="col-10 pr-1">
      <label for="contactGroup">Contacto</label>
      <div class="form-group" >
        <custom-select
          [filterEnabled]="true"
          [bordered]="true"
          name="contactGroup"
          id="contactGroup"
          [(ngModel)]="_selectedContact"
          [(sourceList)]="_optionsContacts"
          required>
        </custom-select>
      </div>
    </div>
    <div class="col-2 pl-1 d-flex align-items-center mt-2">
      <button id="add-group-btn"  type="button" class="btn btn-primary w-100" 
      [disabled]="!_selectedContact?.value" (click)="addContactGroup(_selectedContact)"
      [tooltip]="_appService?.CoreCommonLiterals?.Add">
        <i class="fa fa-plus" aria-hidden="true"></i>{{_appService?.CoreCommonLiterals?.Add}}
      </button>
    </div>
  </div> 
</div>
<div class="d-flex">
  <div class="d-flex flex-column w-100">
    <p class="font-weight-bold">Listado de contactos</p>
    <div class="px-2 mt-3" *ngIf="_data.length">
      <div class="custom-control custom-checkbox mr-3 d-inline-block">
        <input type="checkbox" class="custom-control-input" name="checkAll" id="checkAll" [(ngModel)]="_selectAllElements" (change)="checkAll()">
        <label class="custom-control-label" for="checkAll">{{_appService.CoreCommonLiterals.MultiSelect_All_Male}}</label>
      </div>
      <div class="custom-control custom-checkbox d-inline-block">
        <input type="checkbox" class="custom-control-input" name="unCheckAll" id="unCheckAll" [(ngModel)]="_unCheckAllElements" (change)="unCheckAll()">
        <label class="custom-control-label" for="unCheckAll">{{_appService.CoreCommonLiterals?.None_Male}}</label>
      </div>
      <hr>
    </div>
    <div class="mt-3 form-row w-100 px-2" *ngIf="_data.length">
      <div class="col-4" *ngFor="let item of _data; let i = index;">
        <p class="custom-control custom-checkbox">
          <input class="custom-control-input" [name]="'contact-member-'+i" [id]="'contact-member-'+i" type="checkbox" [disabled]="!item.Enabled" [(ngModel)]="item.Checked" (change)="setEnableSwitch(item)">
          <label class="custom-control-label" [for]="'contact-member-'+i">{{item.DisplayName}}</label>
        </p>
      </div>
    </div>
  </div>
</div>
<div class="text-center ng-star-inserted" *ngIf="!_data.length">
  <i class="fa fa-file-alt fa-4x text-primary"></i>
  <p class="mt-2 text-muted">No se encontraron contactos</p>
</div>